import type { Logger } from "@expert/logging";

import { getRootDispatcher } from "@/analytics";

import { getCustomerDetailsApi } from "./api";

interface CreateCaseRequestBody {
    email?: string;
    firstName?: string;
    lastName?: string;
    product: string;
    feature: string;
    callId: string;
}

export const createCase = async (
    logger: Logger,
    request: CreateCaseRequestBody,
): Promise<{ caseId: string; caseNumber: string } | null> => {
    try {
        const client = getCustomerDetailsApi();
        const apiPath = "v1/case";
        const response = await client
            .post(apiPath, { json: request, retry: 0 })
            .json<{ caseId: string; caseNumber: string }>();

        void getRootDispatcher().dispatchBusinessEvent("CaseCreated", {
            caseId: response.caseId,
            caseNumber: response.caseNumber,
        });

        return response;
    } catch (error: unknown) {
        logger.warn({ error }, "case creation failed");
        return null;
    }
};
